export default function Hero() {
  const handleScroll = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20luxurious%20cinema%20theater%20interior%20with%20warm%20golden%20ambient%20lighting%20velvet%20curtains%20film%20projector%20beam%20atmospheric%20cinematic%20composition%20rich%20textures%20deep%20shadows&width=1600&height=900&seq=hero-bg-cinema&orientation=landscape"
          alt="琪琪影院高清影视观影氛围"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/70 via-background-50/50 to-background-50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-16 md:py-20">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-500/15 border border-primary-500/25 mb-5">
              <span className="w-1.5 h-1.5 rounded-full bg-primary-500"></span>
              <span className="text-xs font-medium text-primary-400 whitespace-nowrap">蓝光画质 · 不缓冲播放</span>
            </div>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-foreground-950 leading-tight tracking-tight">
              琪琪影院
              <br />
              <span className="text-primary-500">高清影视即时点播平台</span>
            </h1>

            <p className="mt-5 text-foreground-500 leading-relaxed max-w-xl mx-auto lg:mx-0 text-sm md:text-base">
              琪琪影院汇聚海量高清影视资源，覆盖电影、电视剧、综艺、动漫、纪录片全品类。依托领先的不缓冲播放技术，从1080P到4K蓝光画质即点即播，全程流畅无卡顿，为每一位影视爱好者打造极致的超清视频在线观看体验。
            </p>

            <div className="mt-6 flex flex-wrap items-center justify-center lg:justify-start gap-5 text-xs md:text-sm">
              <div className="flex items-center gap-1.5 text-foreground-500">
                <i className="ri-movie-line text-primary-400"></i>
                <span>超 <strong className="text-foreground-800">30,000</strong> 部资源</span>
              </div>
              <div className="flex items-center gap-1.5 text-foreground-500">
                <i className="ri-user-smile-line text-primary-400"></i>
                <span>累计 <strong className="text-foreground-800">860万</strong> 用户</span>
              </div>
              <div className="flex items-center gap-1.5 text-foreground-500">
                <i className="ri-timer-flash-line text-primary-400"></i>
                <span>每日 <strong className="text-foreground-800">持续更新</strong> 片源</span>
              </div>
            </div>

            <div className="mt-8 flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4">
              <a
                href="#ranking"
                onClick={(e) => handleScroll(e, '#ranking')}
                className="inline-flex items-center gap-2 px-7 py-3 bg-primary-500 text-background-50 font-semibold rounded-full hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-fire-line"></i>
                查看热门榜单
              </a>
              <a
                href="#index"
                onClick={(e) => handleScroll(e, '#index')}
                className="inline-flex items-center gap-2 px-7 py-3 bg-background-200 text-foreground-700 font-medium rounded-full hover:bg-background-300 transition-colors duration-200 border border-background-300/50 whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-grid-line"></i>
                探索专题合集
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-md lg:max-w-lg">
              <div className="relative rounded-2xl overflow-hidden shadow-2xl shadow-background-50/80">
                <img
                  src="https://readdy.ai/api/search-image?query=Luxurious%20dark%20cinema%20poster%20collage%20featuring%20dramatic%20film%20scenes%20with%20warm%20golden%20spotlight%20effects%20rich%20cinematic%20composition%20elegant%20theater%20atmosphere%20with%20deep%20shadows%20and%20velvet%20textures&width=700&height=900&seq=hero-poster-collage&orientation=portrait"
                  alt="琪琪影院热门影视精选"
                  className="w-full h-auto object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-50/40 to-transparent"></div>

                <div className="absolute bottom-4 left-4 right-4 flex gap-2">
                  <div className="flex-1 bg-background-50/80 backdrop-blur-sm rounded-lg px-3 py-2 flex items-center gap-2">
                    <span className="w-8 h-8 rounded-md bg-accent-500/20 flex items-center justify-center flex-shrink-0">
                      <i className="ri-play-fill text-accent-400 text-sm"></i>
                    </span>
                    <div className="min-w-0">
                      <p className="text-xs text-foreground-700 font-medium truncate">长安三万里</p>
                      <p className="text-xs text-foreground-500">4K蓝光 · 正在热播</p>
                    </div>
                  </div>
                  <div className="flex-1 bg-background-50/80 backdrop-blur-sm rounded-lg px-3 py-2 flex items-center gap-2">
                    <span className="w-8 h-8 rounded-md bg-primary-500/20 flex items-center justify-center flex-shrink-0">
                      <i className="ri-fire-fill text-primary-400 text-sm"></i>
                    </span>
                    <div className="min-w-0">
                      <p className="text-xs text-foreground-700 font-medium truncate">流浪地球2</p>
                      <p className="text-xs text-foreground-500">热度飙升中</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="absolute -top-4 -right-4 w-20 h-20 bg-accent-500/10 rounded-full hidden lg:block"></div>
              <div className="absolute -bottom-4 -left-4 w-16 h-16 bg-primary-500/10 rounded-full hidden lg:block"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}